module.exports = __webpack_public_path__ + "static/media/barChartRet.751b653d.svg";